// Export theme types
export { lightTheme } from './light'
export { darkTheme } from './dark'
export { professionalTheme } from './professional'
export { professionalDarkTheme } from './professionalDark'
export { warmTheme } from './warm'
export { warmDarkTheme } from './warmDark'
export { modernTheme } from './modern'
export { modernDarkTheme } from './modernDark'
export type { Theme } from './light'

import type { Theme } from './light'

// Import theme definitions
import { lightTheme } from './light'
import { darkTheme } from './dark'
import { professionalTheme } from './professional'
import { professionalDarkTheme } from './professionalDark'
import { warmTheme } from './warm'
import { warmDarkTheme } from './warmDark'
import { modernTheme } from './modern'
import { modernDarkTheme } from './modernDark'

/**
 * Alle verfügbaren Theme-Definitionen
 */
export const themes = {
  // Standard-Themes (Legacy)
  light: lightTheme,
  dark: darkTheme,
  
  // Design-Templates (Light)
  professional: professionalTheme,
  warm: warmTheme,
  modern: modernTheme,
  
  // Design-Templates (Dark)
  professionalDark: professionalDarkTheme,
  warmDark: warmDarkTheme,
  modernDark: modernDarkTheme,
} as const

/**
 * Theme-Namen als Typ
 */
export type ThemeName = keyof typeof themes

/**
 * Gruppierung der Themes nach Style und Modus
 */
export const themeGroups = {
  styles: ['professional', 'warm', 'modern'] as const,
  modes: ['light', 'dark'] as const
}

export type ThemeStyle = typeof themeGroups.styles[number]
export type ThemeMode = typeof themeGroups.modes[number]

/**
 * Hilfsfunktion zum Abrufen eines Themes basierend auf Stil und Modus
 */
export function getThemeByStyleAndMode(style: ThemeStyle, mode: ThemeMode): Theme {
  if (mode === 'dark') {
    return themes[`${style}Dark` as ThemeName] || themes.dark
  }
  return themes[style as ThemeName] || themes.light
}
